import { NgModule } from '@angular/core';
import { GitDisabledCommitDialogComponent } from './git-disabled-commit-dialog.component';

@NgModule({
  declarations: [GitDisabledCommitDialogComponent],
  exports: [GitDisabledCommitDialogComponent],
})
export class GitDisabledCommitDialogModule {}
